import FleetTrackLogo from 'assets/images/logos/FleetTrack-logo.svg';
import production from './production';
import staging from './staging';
import development from './development';
import test from './test';

const configVariants = {
  production,
  staging,
  development,
  test,
};
const config = {
  freshworksId: 43000002217,
  partner: {
    url: 'https://app.fleettrackfreight.com',
    name: 'FleetTrack Freight',
    partnerName: 'LB Technology',
    logo: FleetTrackLogo,
  },
  ...configVariants[process.env.NODE_ENV || 'development'],
};

export default config;
